import { createContext } from "react";

export interface ISystemContext 
{
    systemVersion: string | null
}

const defaultSystemContext: ISystemContext = {
    systemVersion: null
};

const SystemContext = createContext<ISystemContext>(defaultSystemContext);
export default SystemContext;
